import CollapsibleTextInput from './CollapsibleTextInput'
export { CollapsibleTextInput }
export default CollapsibleTextInput
